import { Address } from './../interfaces/address';
import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { Distance } from '../interfaces/distance';

@Injectable({
  providedIn: 'root',
})
export class MapService {
  prefix = `${environment.serverUrl}/maps/`;

  constructor(private http: HttpClient) {}

  getAddressSuggestions(query: string): Promise<any> {
    const url = `${this.prefix}address/autosuggest?query=${query}`;
    return this.http.get(url).toPromise();
  }

  getPostalCodeSuggestions(query: string): Promise<Address[]> {
    return this.http.get<Address[]>(`${this.prefix}/address/postalcode/autosuggest?query=${query}`).toPromise();
  }

  getAddressDetails(href: string): Promise<Address> {
    const url = `${this.prefix}address/confirm?href=${href}`;
    return this.http.get<Address>(url).toPromise();
  }

  getFullAddressFromCoordinates(address: Address): Promise<Address> {
    return this.http.post<Address>(`${this.prefix}address/full`, address).toPromise();
  }
  async getDistanceBetweenStops(from: Address, to: Address): Promise<Distance> {
    try {
      return await this.http
        .post<Distance>(`${this.prefix}address/distances`, { from, to })
        .toPromise();
    } catch (error) {
      throw error;
    }
  }
}
